import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container"]
  
  connect() {
    console.log("Dynamic form controller connected")
  }
  
  addField(event) {
    event.preventDefault()
    
    const fieldContainer = event.target.closest('.space-y-2')
    const lastField = fieldContainer.querySelector('div.flex:last-of-type')
    
    if (lastField) {
      const newField = lastField.cloneNode(true)
      const input = newField.querySelector('input')
      if (input) {
        input.value = ''
        input.focus()
      }
      
      // Insert before the Add button
      const addButton = fieldContainer.querySelector('button[data-action*="addField"]')
      fieldContainer.insertBefore(newField, addButton)
    } else {
      // Create a new field from scratch
      const newField = this.createNewField(event.target)
      const addButton = fieldContainer.querySelector('button[data-action*="addField"]')
      fieldContainer.insertBefore(newField, addButton)
    }
  }
  
  removeField(event) {
    event.preventDefault()
    
    const fieldDiv = event.target.closest('div.flex')
    if (fieldDiv) {
      fieldDiv.remove()
    }
  }
  
  createNewField(button) {
    const fieldContainer = button.closest('.space-y-2')
    const existingInput = fieldContainer.querySelector('input')
    
    const div = document.createElement('div')
    div.className = 'flex items-center space-x-2'
    
    const input = document.createElement('input')
    input.type = 'text'
    input.name = existingInput ? existingInput.name : 'field[]'
    input.className = 'flex-1 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm'
    input.placeholder = existingInput ? existingInput.placeholder : 'Enter value'
    
    const removeButton = document.createElement('button')
    removeButton.type = 'button'
    removeButton.className = 'text-red-600 hover:text-red-800'
    removeButton.setAttribute('data-action', 'click->dynamic-form#removeField')
    removeButton.innerHTML = `
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
      </svg>
    `
    
    div.appendChild(input)
    div.appendChild(removeButton)
    
    return div
  }
} 